import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "page",
  ref: "pageRef"
}
const _hoisted_2 = { class: "page_wrap" }
const _hoisted_3 = { class: "performance_tab" }
const _hoisted_4 = { class: "performance_table" }
const _hoisted_5 = { class: "new_box" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item_pic" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item_right" }
const _hoisted_10 = { class: "item_time" }
const _hoisted_11 = { class: "item_title" }
const _hoisted_12 = { class: "item_content" }
const _hoisted_13 = { class: "new_conetnt" }
const _hoisted_14 = { class: "news_title" }
const _hoisted_15 = { class: "news_time" }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NScrollbar = _resolveComponent("NScrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page_top_bg" }, [
      _createElementVNode("img", { src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937195424/news_top_bg.png" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["tab_item", _ctx.tabIndex == 1 ? 'tab_active' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeTab(1)))
        }, " 公司新闻 ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tab_item", _ctx.tabIndex == 2 ? 'tab_active' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeTab(2)))
        }, " 行业资讯 ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tab_item", _ctx.tabIndex == 3 ? 'tab_active' : '']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangeTab(3)))
        }, " 招投标信息 ", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NScrollbar, { style: {"max-height":"800px"} }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "new_item",
                  key: index,
                  onClick: ($event: any) => (_ctx.handleShowHtml(item))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: item.pic,
                      alt: ""
                    }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(item.createTime, "mm/dd")), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(item.createTime, "YYYY")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.content.replace(/<[^>]+>/g, "")), 1)
                  ])
                ], 8, _hoisted_6))
              }), 128))
            ], 512), [
              [_vShow, !_ctx.isShowHtml]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.showHtml.name), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.showHtml.createTime), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.showHtml.content
              }, null, 8, _hoisted_16),
              _createElementVNode("div", {
                style: {"display":"flex","justify-content":"flex-end","cursor":"pointer"},
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
              }, [
                _createVNode(_component_NButton, { text: "" }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" 返回列表 ")
                  ])),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.isShowHtml]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}